import { ITag } from "../../graph/StateTags";

export type TagCellType = { tags: ITag[], meta?: { count?: number } };
export type CellType = string | number | boolean | Date | TagCellType | null;

export interface RowDef
{
    id: string
    index: number
    [key: string]: CellType;
}

export function isTagEntry(value: any): value is TagCellType
{
    return value && value.tags && Array.isArray(value.tags);
}